import { Adapter as e, getAdapter as t } from "../../adapter.js";
import { CustomerConfigurationAdapter as o } from "./configuration/customerConfiguration.adapter.js";
import { CustomerModel as i } from "./customer.model.js";
import { ProfileAdapter as p } from "./profile/profile.adapter.js";
import { ActivityAdapter as a } from "./activity/activity.adapter.js";
class A extends e {
  adapt(r) {
    return new i(
      t(p).adapt(r.profile),
      t(a).adapt(r.activity),
      t(o).adapt(r.configuration)
    );
  }
  serialize(r) {
    return {};
  }
}
export {
  A as CustomerAdapter
};
//# sourceMappingURL=customer.adapter.js.map
